<div id="ro-oil-sticker">
  <div class="oil-sticker-body oil-stamp">
    <div class="new-stamps" *ngIf="printOilStickerSettings">
      <div class="oil-stamp" [ngClass]="{'isOilStickerImproved': isOilStickerImproved}">
        <div class="single-stamp" [ngClass]="!getDefaultSticker() && 'custom-header'"
          [class]="printOilStickerSettings?.stickerClass?.value" [hidden]="!isLoading">
          <div class="stamp-header" *ngIf="getDefaultSticker()">
            <div class="stamp-logo">
              <img [src]="printSample?.logo" alt="logo"
                *ngIf="printSample?.logo || (printOilStickerSettings?.headerType === '' && printSample?.printSample && printSample?.logo)" />
              <!-- <img [src]="printSample?.logo" class="upload-image" *ngIf="printSample?.printSample === false
          && !printOilStickerSettings?.stickerHeaderLogo && printSample?.logo" /> -->
            </div>
            <div class="stamp-brand">
              <h4>{{ printOilStickerSettings?.companyName }}</h4>
              <p>{{ helperService.formatPhoneNumber(printOilStickerSettings?.companyPhone) }}</p>
            </div>
          </div>
          <div class="stamp-header" *ngIf="!getDefaultSticker()" [ngClass]="printSample.logo ? 'bg-white' : ''">
            <img [src]="printSample?.logo" class="upload-image"
              *ngIf="(printSample?.logo && printOilStickerSettings?.stickerHeaderLogo) || (printSample?.printSample === false && !printOilStickerSettings?.stickerHeaderLogo && printSample?.logo)" />
            <!-- <img [src]="printSample?.logo" class="upload-image" *ngIf="printSample?.printSample === false && !printOilStickerSettings?.stickerHeaderLogo && printSample?.logo" /> -->
          </div>
          <div class="stamp-body">
            <p>{{'oil-change.next-service-due'|translate}}</p>
          </div>

          <div class="stamp-footer">
            <div class="stamp-detail">
              <h4><i class="far fa-calendar-alt"></i>
                {{ currentLang === 'fr' ? vehicleData.date : (vehicleData.date | date: 'MMM d, y') }}
              </h4>
            </div>
            <div class="stamp-detail" style="position: relative;">
              <span class="after-content">{{ 'oil-change.or' | translate }}</span>
              <h4>
                <i class="far fa-tachometer-alt"></i> {{ vehicleData.nextMileage | number }} <small>{{
                  vehicleData.measuringUnit }}</small>
              </h4>
            </div>
            <div class="stamp-car-detail">
              <p><i class="fas fa-car"></i>{{ vehicleData.name }}</p>
              <p><i class="fas fa-tachometer-alt"></i>{{ vehicleData.mileage | number }} {{ vehicleData.measuringUnit }}
                {{'oil-change.mi-on'|translate}} {{ newDate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>